import PropTypes from 'prop-types';
import React from 'react';

import './Day.css';

class Day extends React.Component {
  constructor(props) {
    super(props);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick() {
    const { day, handleDayClick, isDaySelectable } = this.props;

    if (isDaySelectable) {
      handleDayClick(day);
    }
  }

  render() {
    const {
      day, isToday, isDayInRange, isDayOutsideOfMonth, isDaySelectable, isSelected,
    } = this.props;
    const dayClassNames = `p2-sm fcl-datepicker-day-style ${
      (isDayOutsideOfMonth || !isDaySelectable) ? 'bg-primary-grey text-color-secondary u-cursor-default' : 'u-cursor-pointer'} ${
      isDayInRange && !isDayOutsideOfMonth && 'day-within-range'} ${
      isSelected && !isDayOutsideOfMonth && 'selected-day'} ${
      isSelected && 'text-color-primary-light'}`;
    return (day
      ? (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
        <td className={`fcl-datepicker-day-td ${!isDaySelectable && 'not-selectable'}`} data-testid="DateSelector" onClick={this.handleOnClick}>
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
          <div className={dayClassNames} disabled={!isDaySelectable} id={`day-${day.format('MM-DD-YYYY')}`} tabIndex="0">
            <div className={isToday ? 'today' : ''}>{day.format('D')}</div>
          </div>
        </td>
      )
      // eslint-disable-next-line jsx-a11y/control-has-associated-label
      : <td />
    );
  }
}

Day.propTypes = {
  day: PropTypes.shape(),
  handleDayClick: PropTypes.func.isRequired,
  isDayInRange: PropTypes.bool,
  isDayOutsideOfMonth: PropTypes.bool.isRequired,
  isDaySelectable: PropTypes.bool,
  isSelected: PropTypes.bool,
  isToday: PropTypes.bool,
};

Day.defaultProps = {
  day: {},
  isDayInRange: false,
  isDaySelectable: false,
  isSelected: false,
  isToday: false,
};

export default Day;
